import ManagerLeftSidebar from './manager-left-sidebar'

export default ManagerLeftSidebar
